// TODO: remove tab state and update demand on conversation obj (open and history)

export const resetTabsObj = () => {
  return {
    type: 'RESET_TABS_OBJ',
    payload: {},
  }
}
export const resetTabsStatus = (reset) => {
  return {
    type: 'RESET_TABS_STATUS',
    payload: reset,
  }
}

export const tabsError = (error) => {
  return {
    type: 'TABS_ERROR',
    payload: error,
  }
}

export const getTabs = (data) => {
  return {
    type: 'GET_TABS',
    payload: data,
  }
}
export const setTabs = (skillId, data) => {
  return {
    type: 'SET_TABS',
    payload: { skillId, data },
  }
}

export const getTab = (data) => {
  return {
    type: 'GET_TAB',
    payload: data,
  }
}
export const setTab = (data) => {
  return {
    type: 'SET_TAB',
    payload: data,
  }
}
